import { FC } from "react";
import { MantineColor, Text } from "@mantine/core";
import { Link } from "react-router-dom";

interface TextWithLinksProps {
  text: string;
  color: MantineColor;
}

const urlRegex = /(https?:\/\/[^\s]+)/g;

const TextWithLinks: FC<TextWithLinksProps> = ({ text, color }) => {
  const parts = text.split(urlRegex);

  return (
    <Text style={{ whiteSpace: "pre-line" }} c={color}>
      {parts.map((part, index) => {
        if (urlRegex.test(part)) {
          return (
            <Link
              to={part}
              target="_blank"
              rel="noopener noreferrer"
              key={index}
              style={{ color: color }}
            >
              {part}
            </Link>
          );
        }
        return part;
      })}
    </Text>
  );
};

export default TextWithLinks;
